import React from 'react';
interface ProductScreenFrameProps {
  assetId: string;
  title: string;
  src?: string;
  alt?: string;
  aspectClassName?: string;
  imageClassName?: string;
  className?: string;
  placeholderLabel?: string;
}
const SkeletonLine = ({
  width
}: {
  width: string;
}) => <div className={`h-2 rounded-full bg-gray-200 ${width}`} data-id="element-233" data-mp="19czmfetpysyt" />;
export const ProductScreenFrame = ({
  assetId,
  title,
  src,
  alt = '',
  aspectClassName = 'aspect-[4/3]',
  imageClassName = 'object-cover',
  className = '',
  placeholderLabel
}: ProductScreenFrameProps) => {
  const isRealScreen = Boolean(src);
  return <figure className={`overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm sm:rounded-2xl ${className}`} data-id="element-234" data-mp="1s9ippnhudmng">
    <figcaption className="flex min-h-11 flex-wrap items-center gap-2.5 border-b border-gray-200 bg-gray-50/90 px-3 py-2.5 sm:px-4" data-id="element-235" data-mp="1o7e2b6hzlm99">
      <span className="hidden gap-1.5 sm:flex" aria-hidden="true" data-id="element-236" data-mp="2ksfy2iqi0uqj">
        <span className="h-2 w-2 rounded-full bg-gray-400" data-id="element-237" data-mp="2fytj2jwv4erk" />
        <span className="h-2 w-2 rounded-full bg-gray-400" data-id="element-238" data-mp="1enbpz521dfbi" />
        <span className="h-2 w-2 rounded-full bg-gray-400" data-id="element-239" data-mp="1entsukj7erse" />
      </span>
      <p className="min-w-0 flex-1 truncate text-xs font-normal text-gray-600" data-id="element-240" data-mp="1jl3j22ef37ha">{title}</p>
      {placeholderLabel && <span className="shrink-0 text-xs font-medium uppercase tracking-[0.12em] text-gray-600" data-id="element-241" data-mp="14wpglskwxl19">{placeholderLabel}</span>}
      {!isRealScreen && <span className="shrink-0 text-xs font-medium uppercase tracking-[0.12em] text-gray-600" data-id="element-242" data-mp="vwk8fg7waim1">{assetId}</span>}
    </figcaption>

    <div className={`relative overflow-hidden bg-gray-50 ${aspectClassName}`} data-id="element-243" data-mp="10vx6kx47vc3x">
      {isRealScreen ? <img src={src} alt={alt} loading="lazy" decoding="async" className={`absolute inset-0 h-full w-full ${imageClassName}`} data-id="element-244" data-mp="lywfmvtunl6i" /> : <>
        <div className="absolute inset-0 flex gap-4 p-4 sm:gap-5 sm:p-6" aria-hidden="true" data-id="element-245" data-mp="qxzhk7ej9ba9">
          <div className="hidden w-1/5 shrink-0 flex-col gap-3 sm:flex" data-id="element-246" data-mp="2gdp3g8ohr7nw">
            <div className="h-7 rounded-lg bg-gray-200" data-id="element-247" data-mp="2lbqqt5sy9t56" />
            <div className="h-5 rounded-lg bg-gray-200/70" data-id="element-248" data-mp="2l94jn79z1fnh" />
            <div className="h-5 rounded-lg bg-gray-200/70" data-id="element-249" data-mp="2jv4h881nssjn" />
            <div className="h-5 rounded-lg bg-gray-200/70" data-id="element-250" data-mp="2evi3zyltzcau" />
          </div>
          <div className="flex min-w-0 flex-1 flex-col gap-4" data-id="element-251" data-mp="2exl3racscjsr">
            <div className="flex items-center justify-between gap-4" data-id="element-252" data-mp="29wx7a95sfar5">
              <div className="h-4 w-1/3 rounded-full bg-gray-300" data-id="element-253" data-mp="25vbv6q12v0i0" />
              <div className="h-6 w-20 rounded-lg bg-gray-200" data-id="element-254" data-mp="32kta7vly9ywd" />
            </div>
            <div className="grid flex-1 gap-4 sm:grid-cols-2" data-id="element-255" data-mp="32mxam3kn4frw">
              <div className="flex flex-col gap-2.5 rounded-xl border border-gray-200 bg-white p-4" data-id="element-256" data-mp="2xmrikmagkr9a">
                <SkeletonLine width="w-2/3" data-id="element-257" data-mp="2stow0y43mi2l" /><SkeletonLine width="w-full" data-id="element-258" data-mp="2sswyhhqxya9o" /><SkeletonLine width="w-5/6" data-id="element-259" data-mp="2oto54dztceen" /><SkeletonLine width="w-1/2" data-id="element-260" data-mp="2osd3ajpxhgq6" />
              </div>
              <div className="hidden flex-col gap-2.5 rounded-xl border border-gray-200 bg-white p-4 sm:flex" data-id="element-261" data-mp="3lbaqv1tid41d">
                <SkeletonLine width="w-1/2" data-id="element-262" data-mp="3gk2ebwwvt2jz" /><SkeletonLine width="w-full" data-id="element-263" data-mp="3gjsm02od6jb4" /><SkeletonLine width="w-3/4" data-id="element-264" data-mp="3gihi82ux5bk0" /><SkeletonLine width="w-2/3" data-id="element-265" data-mp="1327pdnrwm5ub" />
              </div>
            </div>
          </div>
        </div>
        <span className="absolute bottom-3 left-3 rounded-full border border-dashed border-gray-400 bg-white/95 px-3 py-1 text-[10px] font-semibold uppercase tracking-[0.14em] text-gray-600" data-id="element-266" data-mp="180iytxeaeec0">Product screen needed</span>
      </>}
    </div>
  </figure>;
};